// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const ScanProfileTierSchema = z.enum(['STEALTH','BALANCED','AGGRESSIVE'] as const);

export type ScanProfileTierType = `${z.infer<typeof ScanProfileTierSchema>}`

export default ScanProfileTierSchema;
